import Vue from 'vue'
import App from './App.vue'
import info from '../package.json'

import ODS from '@ods/ods' // eslint-disable-line
import i18n from './lang/i18n.js' // eslint-disable-line
import { closest } from './utils/ie' // eslint-disable-line

import '@ods/ods/lib/theme-onesait/index.css'
import '@/assets/scss/main.scss'
import '@/axios-config'
import router from './router'
import store from './store/store.js'

Vue.config.productionTip = false

const hostname = window.location.hostname;
console.log('window.location.hostname ', hostname);
console.log('window.location ', window.location);
if (hostname.includes('efactura.red.es')) { 
  console.log('Accediendo desde el entorno red.es');
  Vue.prototype.$apiBaseUrl = 'red.es'; 
} else if (hostname.includes('efactura')) { //'dev-efactura-gcp.b2bconecta.com'
  console.log('Accediendo desde el entorno REE');
  Vue.prototype.$apiBaseUrl = 'ree'; 
}

closest()

require('vue-moment')

Vue.use(ODS, { i18n: (key, value) => i18n.t(key, value) })

// Devuelve el dia en formato dd/mm/yyyy
Vue.filter('getDay', function (date) {
  const d = new Date(date)
  const day = d.getDate() + '/' + d.getMonth() + '/' + d.getFullYear()
  return day
})
// Devuelve el dia en formato hh/mm/ss
Vue.filter('getTime', function (date) {
  const d = new Date(date)
  const time = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
  return time
})

if (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'preproduction') {
  window.odsInfo = {
    'ods-version': ODS.version,
    project: info.name,
    author: info.author
  }
}

new Vue({
  i18n,
  router,
  store,
  template: '<App/>',
  beforeCreate () {
    this.$store.commit('initialStore')
  },
  render: h => h(App)
}).$mount('#app')
